export enum EstadoAlumnoCarrera {
    REGISTRADO = 0,
    INICIALIZACION_KV_PENDIENTE = 1,
    KV_INICIALIZADO = 2,
    ACCESO_BLOQUEADO = 3
  }